"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var App_1 = require("./components/App");
ReactDOM.render(React.createElement(App_1.App, null), document.getElementById('app-container'));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./src/js/index.js
// module id = 13
// module chunks = 0